import { render, staticRenderFns } from "./GlobalLoader.vue?vue&type=template&id=4ce2b356&lang=pug"
import script from "./GlobalLoader.vue?vue&type=script&lang=js"
export * from "./GlobalLoader.vue?vue&type=script&lang=js"
import style0 from "./GlobalLoader.vue?vue&type=style&index=0&id=4ce2b356&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports